import { Flex, Text } from '@chakra-ui/react'

import { formatDateTime, formatTime } from '../../utils/format-time'
import { captalizingSentence } from '../helpers/Helpers'

type Props = {
  city: string
  area: string
  vehicle: string
  time: number
  price: number
  licencePlate: string
  startAt?: string
  endAt?: string
}

type IVehicleList = {
  car: string
  motorcycle: string
  bus: string
  truck: string
}

const vehicleList: IVehicleList = {
  car: 'Carro',
  motorcycle: 'Moto',
  bus: 'Ônibus',
  truck: 'Caminhão',
}

const Card = ({ city, area, vehicle, time, price, licencePlate, startAt, endAt }: Props) => {
  return (
    <Flex
      w="100%"
      h="100%"
      direction="column"
      bg="white"
      borderRadius="15px"
      boxShadow="0px 0px 50px rgba(0, 52, 127, 0.1)"
    >
      <Flex
        w="100%"
        justify="space-between"
        borderBottomWidth="3px"
        borderColor="rgba(221, 228, 241, 0.5)"
        p="20px"
        fontSize="20px"
        fontWeight="500"
      >
        <Text>Total</Text>
        <Text>R$ {price ? (price / 100).toFixed(2) : '0,00'}</Text>
      </Flex>
      <Flex w="100%" h="100%" direction="column" fontSize="13px" gap="20px" p="20px">
        <Text fontSize="15px">Resumo</Text>
        <Flex w="100%" justify="space-between">
          <Text>Cidade</Text>
          <Text>{city ? captalizingSentence(city) : '---'}</Text>
        </Flex>
        <Flex w="100%" justify="space-between">
          <Text>Área</Text>
          <Text>{area ? captalizingSentence(area) : '---'}</Text>
        </Flex>
        <Flex w="100%" justify="space-between">
          <Text>Veículo</Text>
          <Text>{vehicle ? `${vehicleList[vehicle as keyof IVehicleList]} - ${licencePlate}` : '---'}</Text>
        </Flex>
        <Flex w="100%" justify="space-between">
          <Text>Tempo</Text>
          <Text>{formatTime(time)}</Text>
        </Flex>
        {startAt && (
          <Flex w="100%" justify="space-between">
            <Text>Início</Text>
            <Text>{formatDateTime(startAt)}</Text>
          </Flex>
        )}
        {endAt && (
          <Flex w="100%" justify="space-between">
            <Text>Término</Text>
            <Text>{formatDateTime(endAt)}</Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default Card
